import { Component } from '@angular/core';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';

@Component({
  selector: 'app-pending-vendor-approval',
  templateUrl: './pending-vendor-approval.component.html',
  styleUrl: './pending-vendor-approval.component.scss'
})
export class PendingVendorApprovalComponent {
  chnage_request:boolean =false
  is_reject_vendor:boolean = false
  is_approve_vendor:boolean =false
  status:string=''
  constructor(
    private vendorService: VendorTsService
) { }

  ngOnInit() {
    const chnage_request = history.state.business_name;
    if (chnage_request) {
      this.chnage_request=true
    }

    this.vendorService.checkIfVendor().then((res)=>{
      this.is_approve_vendor=res.message.is_approve_vendor
      this.is_reject_vendor=res.message.is_reject_vendor

      if (this.is_reject_vendor) {
        this.status = "Your request is rejected by Rockman Team!";
      } else if (this.chnage_request) {
        this.status = "Your request is successfully submitted, and is under review from Rockman Team!";
      } else {
        this.status = "Your registration request is successfully submitted, and is under review from Rockman Team!";
      }

    }).catch((error)=>{
      console.log(error)
    })


  }
}
